const transformTenant = (data) => {
    if (!data.tenantName && !data.tenantSurname) {
        return null;
    }

    return {
        name: data.tenantName,
        surname: data.tenantSurname,
    };
};

export default {
    transform(data) {
        return {
            propertyId: data.propertyId,
            startDate: data.startDate,
            endDate: (data.termless || !data.endDate) ? undefined : data.endDate,
            termless: Boolean(data.termless),
            status: data.bookingStatus,
            statusComment: data.statusComment || '',
            creatorType: 'user',
            tenant: transformTenant(data),
        };
    },
}



// WEBPACK FOOTER //
// ./src/transformers/output/property-calendar/index.js